module.exports = __webpack_public_path__ + "img/ic_pk_default.20981864.png";